import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import cuid from "cuid";
import React from 'react'
import { withTranslation } from 'react-i18next';
import { List, Icon, Dimmer } from 'semantic-ui-react'
import { ThemeProvider } from 'styled-components';
import {ReactElementResize} from 'react-element-resize';
import { Box, Flex } from 'rebass'


import { map } from 'lodash'

import { VIDEO_PLAYER_KEY } from "../definitions";
import theme from '~/theme'
import { __ } from '~/i18n'
import Video from '~/components/video'
import { SimpleErrorBoundary } from '~/components/errors'
import {
  Description,
  VideoContainer,
  VideoPlayerContainer,
  VideoFooter,
  VideoTitle,
  Playlist,
  PosterContainer,
  Poster,
  AlignBox
} from "~/components/video-playlist";

import logic from './logic'
import BuyButton from '../buy-button/button'


class VideoPlayer extends React.Component {

  state = {
  };

  showPurchase = () => {
    return !this.props.hasAccess && !this.props.hideBuyButton;
  };

  playVideo = (index) => {
    const { setActiveVideo } = this.props.actions;

    setActiveVideo(index);
  };

  onTrailerStateChange = (state, prevState) => {
    const { trailerFinished, trailerRestarted } = this.props.actions;
    if(!prevState.ended && state.ended) {
      trailerFinished();
    } else if(prevState.ended && !state.ended) {
      trailerRestarted();
    }
  };

  isDisabled = () => {
    const { loading, failed, hasQuantity } = this.props;
    return loading || failed || !hasQuantity
  };

  handleHeightChange = ({width, height}) => {
    if(this.state.videoHeight !== height) {
      this.setState({videoHeight: height});
    }
  };

  render() {
    const {
      loading,
      failed,
      hasQuantity,
      product,
      videoPlayer,
      showPrice,
      text,
      trailerDone,
      activeVideo,
      showPlaylist,
      mainPoster,
      title,
      hasAccess,
      description,
      hideVideo
    } = this.props;

    const { videoHeight } = this.state;

    let videoContent;


    if (videoPlayer && hasAccess && activeVideo) {
      const videos = map(videoPlayer.videos, (video, index) => {
        return (
          <List.Item active={ video.id === activeVideo.id } as='a' key={ video.id } onClick={(e) => {
            e.preventDefault();
            this.playVideo( index )
          }}>
            <Icon name='play circle outline' size='large' />
            <List.Content>
              <List.Header>{ video.name || `${__('Video')} #${ index + 1}` }</List.Header>
            </List.Content>
          </List.Item>
        );
      });
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={[1, showPlaylist ? 10/16 : 1, showPlaylist ? 12/16 : 1]}>
            <ReactElementResize debounceTimeout={50} onResize={this.handleHeightChange}>
              { () => <Video
                hlsSource={ activeVideo.hls_source }
                poster={ mainPoster }
                onStateChange={ this.onTrailerStateChange }
              /> }
            </ReactElementResize>
          </Box>
          { showPlaylist ? <Box width={[1, 6/16, 4/16]}>
            <Playlist relaxed divided size="big" videoHeight={ videoHeight }>
              { videos }
            </Playlist>
          </Box> : null }
        </Flex>
      )
    } else if (videoPlayer && videoPlayer.trailer_hls_source && !hasAccess) {
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={1}>
            <Video
              hlsSource={ videoPlayer.trailer_hls_source }
              poster={ mainPoster }
              onStateChange={ this.onTrailerStateChange }
            />
          </Box>
        </Flex>
      )
    } else if (videoPlayer && !videoPlayer.trailer_hls_source && !hasAccess && mainPoster) {
      videoContent = (
        <Flex flexWrap='wrap'>
          <Box width={1}>
            <PosterContainer>
              <Poster image={mainPoster}/>
            </PosterContainer>
          </Box>
        </Flex>
      )
    }

    return (
      <ThemeProvider theme={theme}>
        <VideoContainer className="gfy-plugin-container">
          { !hideVideo ? <VideoPlayerContainer>
            { videoContent }
            <Dimmer active={ trailerDone && this.showPurchase() }>
              <BuyButton
                {...this.props}
              />
            </Dimmer>
          </VideoPlayerContainer> : null }
          <VideoFooter>
            { product && videoPlayer ?
              <div>
                <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 }>
                  <Box px={ 4 } width={ [ 0.5, 10/16, 10/16 ] }>
                    <VideoTitle>{ title }</VideoTitle>
                  </Box>
                  <AlignBox textAlign='right' px={ 4 } width={ [ 0.5, 6/16, 6/16 ] }>
                    { this.showPurchase() ? (
                        <BuyButton
                          {...this.props}
                        />
                      )
                      : null }
                  </AlignBox>
                </Flex>
                { description ? <Flex flexWrap='wrap' py={ 4 } alignItems={ 'center' } mx={ -4 }>
                  <Box px={ 4 } width={ 1 }>
                    <SimpleErrorBoundary message={ __('Unable to load video description.') }>
                      <Description description={ description } />
                    </SimpleErrorBoundary>
                  </Box>
                </Flex> : null }
              </div>
            : null }
          </VideoFooter>
        </VideoContainer>
      </ThemeProvider>
    )
  }
}


const DecoratedVideoPlayer = withTranslation('cart')(logic(VideoPlayer))

DecoratedVideoPlayer.defaultProps = Object.create({gfyPlugin: VIDEO_PLAYER_KEY}, {
  id: {
    enumerable: true,
    get: () => cuid()
  }
});

export default  DecoratedVideoPlayer
